import React, { useState, useEffect } from 'react';

const NotificationComponent = () => {
  const [permission, setPermission] = useState(Notification.permission);

  // 通知の権限をリクエストする関数
  const requestNotificationPermission = async () => {
    if (!("Notification" in window)) {
      console.error("このブラウザは通知をサポートしていません。");
      return;
    }

    try {
      let permission;
      if (typeof Notification.requestPermission === "function") {
        permission = await Notification.requestPermission();
      } else if (typeof navigator.permissions?.query === "function") {
        const result = await navigator.permissions.query({ name: "notifications" });
        permission = result.state;
      }
      setPermission(permission); // 権限の状態を更新
      if (permission === "granted") {
        console.log("通知の権限が許可されました");
      } else {
        console.warn("通知の権限が許可されていません");
      }
    } catch (error) {
      console.error("通知の許可リクエスト中にエラーが発生しました:", error);
    }
  };

  // 通知を送る関数
  const notify = (message) => {
    if (Notification.permission === "granted") {
      new Notification(message);
    } else {
      console.error("通知の権限がありません");
    }
  };

  useEffect(() => {
    // ページがロードされたときに通知の権限を確認
    if (Notification.permission !== "granted" && Notification.permission !== "denied") {
      requestNotificationPermission();
    }
  }, []);

  useEffect(() => {
    // 通知を送る時間（24時間形式）
    const notificationTimes = [
      { hour: 7, minute: 0, message: 'おはようございます！メンタル記録をつけましょう。' },
      { hour: 12, minute: 0, message: 'お昼です！メンタル記録をチェックしてください。' },
      { hour: 20, minute: 0, message: 'こんばんは！今日のメンタルを記録しましょう。' },
    ];

    const timer = setInterval(() => {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      notificationTimes.forEach(({ hour, minute, message }) => {
        if (currentHour === hour && currentMinute === minute) {
          console.log(`通知を送信します: ${message}`);
          notify(message);
        }
      });
    }, 60000); // 1分ごとにチェック

    return () => clearInterval(timer); // クリーンアップ
  }, [notify]);

  return (
    <div>
      <button onClick={() => notify('テスト通知です')}>テスト通知を送信</button>
      <button onClick={requestNotificationPermission}>通知の権限をリクエスト</button>
      <p>通知権限: {permission}</p>
    </div>
  );
};

export default NotificationComponent;
